<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded">
<p class="dedf" style="font-style: normal;"><a class="page" id="pv"></a>For Beatrice,</p>
<p class="ded" style="font-style: normal;">whose sense of <i>Polskość</i> amazes me</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-pacyga-0005.vue?0c61faf8